import axios from 'axios'
import config from '../config'
import { getDoctorToken } from '../utils'

const bookedAppointmentActivityApi = async (params) => {
    console.log("ACTIVITY API CALLED")
    const response = await axios({
        url: `${config.api.base_url}book-appointment/appointment-call-activity`,
        method: "post",
        data: params,
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${getDoctorToken()}`

        }
    })
    return response
}

export default bookedAppointmentActivityApi